/**
 * Reads query-string values without treating "+" as a space.
 *
 * The Cognito invite email builds links like
 *   /set-password?username=jane+para@example.com&tmp-password=...
 * with the raw e-mail address. URLSearchParams (and react-router's useSearchParams)
 * decode "+" as " ", turning the username into "jane para@example.com", so the
 * sign-in fails with "Incorrect username or password". Percent-encoded values
 * (e.g. %26 for "&") still decode normally.
 */
export const parseRawSearchParams = (search: string): URLSearchParams =>
  new URLSearchParams(search.replace(/\+/g, '%2B'));

export const getRawSearchParam = (name: string, search = window.location.search): string | null =>
  parseRawSearchParams(search).get(name);
